import { createNoParamsServerSidePaginatedFetcher } from '../contexts/Fetcher';
import { apiUserDownloads } from '../resources/api/apiUserDownloads';
import { useContext } from 'react';

import { OrganizationContext } from '../contexts/OrganizationContext';

const { useListDownloads } = apiUserDownloads;

export const UserDownloadsFetcher = createNoParamsServerSidePaginatedFetcher(() => {
  const { organization } = useContext(OrganizationContext);
  const { execute } = useListDownloads(organization ?? undefined);
  return execute;
});
